 
import './App.css';
import LandingPage from './components/landingPage';
// import "./landingPage/LandingPage.css"

function App() {
  return (
      <div className="App">
              
      <LandingPage />
     </div>
  );
}

export default App;
